import { useOnlineUsers } from '../../contexts/OnlineUsersContext';
import styles from './OnlineUsers.module.css';

const OnlineUsers = () => {
  const { onlineUsers, onlineCount, loading } = useOnlineUsers();

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.loading}>Loading online users...</div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.onlineDot}></span>
        <span className={styles.title}>Online ({onlineCount})</span>
      </div>
      
      {onlineUsers.length === 0 ? (
        <div className={styles.empty}>Keine anderen User online</div>
      ) : (
        <div className={styles.userList}>
          {onlineUsers.map(user => (
            <div key={user.id} className={styles.userItem}>
              <span className={styles.avatar}>{user.avatar_emoji || '👤'}</span>
              <span className={styles.tagname}>{user.tagname}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OnlineUsers;